import {errorHandler} from "@/lib/errorHandler";
import PersonalInformation from "@/pages/agreement/PersonalInformation";
import PrivacyPolicy from "@/pages/agreement/PrivacyPolicy";
import TermsOfUse from "@/pages/agreement/TermsOfUse";
import AuthorizationPage from "@/pages/authorization/AuthorizationPage.vue";
import CheckListPage from "@/pages/authorization/CheckListPage.vue";
import CodePage from "@/pages/authorization/CodePage.vue";
import OAuthPage from "@/pages/authorization/OAuthPage.vue";
import RegistrationPage from "@/pages/authorization/RegistrationPage.vue";
import HomePage from "@/pages/landing/HomePage.vue";
import AboutUsPage from "@/pages/personal_area/AboutUsPage.vue";
import AllCoursesCategoriesPage from "@/pages/personal_area/AllCoursesCategoriesPage.vue";
import AllCoursesPage from "@/pages/personal_area/AllCoursesPage.vue";
import BlogPage from "@/pages/personal_area/BlogPage.vue";
import CoursePage from "@/pages/personal_area/CoursePage.vue";
import DashbordPage from "@/pages/personal_area/DashbordPage.vue";
import DiaryPage from "@/pages/personal_area/DiaryPage.vue";
import FAQPage from "@/pages/personal_area/FAQPage.vue";
import HelpPage from "@/pages/personal_area/HelpPage.vue";
import LessonPage from "@/pages/personal_area/LessonPage.vue";
import LibraryPage from "@/pages/personal_area/LibraryPage.vue";
import MyCourses from "@/pages/personal_area/MyCourses.vue";
import NoteIdPage from "@/pages/personal_area/NoteIdPage.vue";
import NotePage from "@/pages/personal_area/NotePage.vue";
import SeparateTestPreviousPage from "@/pages/personal_area/SeparateTestPreviousPage.vue";
import TestPage from "@/pages/personal_area/TestPage.vue";
import UserCabinet from '@/pages/personal_area/UserCabinet.vue';
import {
    canEnterToRegistration,
    canEnterToUserCabinet,
    canEnterToUserPortal,
    guestAuthorization,
    isGuestSession,
} from "@/router/helpers";
import {createRouter, createWebHistory} from 'vue-router';
import PracticumPage from "@/pages/personal_area/PracticumPage.vue";


// creating routes to all pages
const routes = [
    {
        path: '/',
        name: 'homePage',
        component: HomePage,
        props: true
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: PrivacyPolicy,
    },
    {
        path: '/terms',
        name: 'terms',
        component: TermsOfUse,
    },
    {
        path: '/personal',
        name: 'personal',
        component: PersonalInformation,
    },
    {
        path: '/code',
        name: 'codePage',
        component: CodePage,
        props: true
    },
    {
        path: '/AboutUsPage',
        name: 'AboutUsPage',
        component: AboutUsPage
    },
    {
        path: '/FAQPage',
        name: 'FAQPage',
        component: FAQPage
    },
    {
        path: '/HelpPage',
        name: 'HelpPage',
        component: HelpPage
    },
    {
        path: '/login',
        name: 'loginPage',
        component: AuthorizationPage,
        beforeEnter: async (to, before, next) => {
            await canEnterToRegistration(function (token) {
                if (token) {
                    next({name: 'dashboardPage'});
                } else {
                    next();
                }
            })
        }
    },
    {
        path: '/auth/:provider/callback',
        name: 'OAuthPage',
        component: OAuthPage,
        beforeEnter: async (to, before, next) => {
            await canEnterToRegistration(function (token) {
                if (token) {
                    next({name: 'dashboardPage'});
                } else {
                    next();
                }
            })
        }
    },
    {
        path: '/registration',
        name: 'registrationPage',
        component: RegistrationPage
    },

    {
        path: '/main',
        name: 'user',
        component: UserCabinet,
        children: [
            {
                path: 'dashboard',
                name: 'dashboardPage',
                component: DashbordPage
            },
            {
                path: 'diary',
                name: 'diaryPage',
                component: DiaryPage,
                beforeEnter(to, before, next) {
                    if (isGuestSession()) {
                        next({
                            name: "registrationPage"
                        })
                        return;
                    }
                    next();
                }
            },
            {
                path: 'diary/:id',
                name: 'noteIdPage',
                props: true,
                component: NoteIdPage
            },
            {
                path: 'note',
                name: 'notePage',
                component: NotePage
            },
            {
                path: 'courses',
                name: 'myCoursesPage',
                component: MyCourses
            },
            {
                path: '/all/courses/categories',
                name: 'allCoursesCategoriesPage',
                props: true,
                component: AllCoursesCategoriesPage
            },
            {
                path: '/all/courses/:categorySlug',
                name: 'allCoursesPage',
                props: true,
                component: AllCoursesPage
            },
            {
                path: '/courses/:courseId',
                props: true,
                name: 'coursePage',
                component: CoursePage
            },
            {
                path: '/testing/:testingId',
                name: 'currentTestingPage',
                props: true,
                component: SeparateTestPreviousPage,
                beforeEnter(to, before, next) {
                    if (isGuestSession()) {
                        next({
                            name: "registrationPage"
                        })
                        return;
                    }
                    next();
                }
            },
            {
                path: '/course/:courseId/:lessonId',
                name: 'lessonPage',
                props: true,
                component: LessonPage
            },
            {
                path: 'practicum',
                name: 'practicumPage',
                component: PracticumPage,
                beforeEnter(to, before, next) {
                    if (isGuestSession()) {
                        next({
                            name: "registrationPage"
                        })
                        return;
                    }
                    next();
                }
            },
            {
                path: 'library',
                name: 'libraryPage',
                component: LibraryPage
            },
            {
                path: '/library/:articleId',
                name: 'currentArticle',
                props: true,
                component: BlogPage
            },
            {
                path: '/testing/passing/:testingId',
                name: 'testingPassingPage',
                props: true,
                component: TestPage
            },
            {
                path: 'help',
                name: 'helpPage',
                component: HelpPage
            },
            {
                path: 'about',
                name: 'aboutPage',
                component: AboutUsPage
            },

        ],
        beforeEnter: async (to, before, next) => {
            await canEnterToUserPortal(function (user) {
                if (user) {
                    if (!user.userParams.passedChecklist) {
                        next({name: 'checklistPage'})
                    } else {
                        next();
                    }
                } else {
                    guestAuthorization();
                    next();
                    // next({name: 'login'});
                }
            })
        }
    },
    {
        path: '/checklist',
        name: 'checklistPage',
        component: CheckListPage,
        beforeEnter: async (to, before, next) => {
            await canEnterToUserCabinet(function (checklistId) {
                if (checklistId) {
                    errorHandler({name: 'checklist', status: 400, get: true});
                    next({name: 'dashboardPage'});
                } else {
                    next()
                }
            })
        }
    },

];

// creating Vue-Router instance with normal history mode
const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;